import React, { Fragment, useState, useEffect } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {
  Breadcrumbs,
  Grid,
  Typography,
  Chip,
} from "@material-ui/core";
import { withStyles, makeStyles, createStyles } from "@material-ui/core/styles";
import HomeStyles from "pages/HomeStyles";
import {
  setCurrentPage,
  getPhotoShootMapDataHokuden,
  setPictreeMapType,
} from "actions";
import * as C from "components";
import PhotoShootMapHokuden from "components/PicTree/Game/Map/PhotoShootMapHokuden";
import SingleSelect from "components/Select/SingleSelect";
import CalendarRangePicTreeHokuden from "components/Calendar/CalendarRangePicTreeHokuden";

const useStyles = makeStyles((theme) =>
  createStyles({
    loaderBox: {
      width: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      minHeight: 280,
    },
    loaderBarImg: {
      width: 40,
    },
    breadcrumbs: {
      marginTop: 16,
      minHeight: 30,
    },
    gridSection: {
      marginTop: theme.spacing(1),
    },
  })
);

const PicTreeMapHokuden = ({
  currentPage,
  setCurrentPage,
  pageTopLoader,
  photoShootMapData,
  getPhotoShootMapDataHokuden,
  setPictreeMapType,
  dateRangePicTreeHokuden,
  selectedSeason,
}) => {
  const classes = useStyles();
  const [chartSize, setChartSize] = useState({ name: "撮影ずみ", value: "taken" });
  const [photoType, setPhotoType] = useState("taken");
  const [initialDataCall, setInitialDataCall] = useState(true);
  const [singleSelectDisabled, setSingleSelectDisabled] = useState(false);
  const [mapData, setMapData] = useState([]);

  useEffect(() => {
    setCurrentPage(window.location.pathname);
  }, []);

  useEffect(() => {
    if (
      dateRangePicTreeHokuden[0] !== null &&
      dateRangePicTreeHokuden[1] !== null &&
      initialDataCall
    ) {
      getPhotoShootMapDataHokuden({type: "denchu", filter: "taken"});
      setInitialDataCall(false);
    }
  }, [dateRangePicTreeHokuden]);

  useEffect(() => {
    if (photoType === "taken") {
      setMapData(photoShootMapData?.taken);
    } else if (photoType === "untaken") {
      setMapData(photoShootMapData?.untaken);
    } else {
      const combinedData = [
        ...(photoShootMapData?.taken || []).map((item) => ({ ...item, status: "taken" })),
        ...(photoShootMapData?.untaken || []).map((item) => ({ ...item, status: "untaken" })),
      ];
      setMapData(combinedData);
    }
  }, [photoShootMapData, photoType]);

  const handleChange = (event) => {
    setChartSize(event.target);
    setPictreeMapType(event.target.value);
    setPhotoType(event.target.value);
    getPhotoShootMapDataHokuden({type: "denchu", filter: event.target.value});
  };

  return (
    <Fragment>
      <C.ContentWrapper>
        <Grid
          container
          spacing={0}
          direction="row"
          style={{ marginTop: -16, marginBottom: 8 }}
          justifyContent="space-between"
        >
          <Grid item>
            <Breadcrumbs separator="›" className={classes.breadcrumbs}>
              <Typography>PicTrée ほくでん</Typography>
              <Typography variant="body1">撮影</Typography>
              <Typography variant="body1">地図表示</Typography>
            </Breadcrumbs>
          </Grid>
          <Grid item className={classes.fillRemailSpace}></Grid>
          <Grid item>
            <CalendarRangePicTreeHokuden
              mDate={"2025/07/12"}
              page="pictree-map"
              singlePeriod
            />
          </Grid>
        </Grid>

        <Grid
          container
          spacing={0}
          direction="row"
          style={{ marginTop: 16, marginRight: 8, marginBottom: 8 }}
          justifyContent="flex-start"
        >
          <Grid item style={{ marginTop: 0, marginLeft: 8, }}>
            <SingleSelect
              selected={chartSize}
              options={[
                { name: `撮影済み`, value: "taken" },
                // { name: `未撮影`, value: "untaken" },
                // { name: `撮影済み + 未撮影`, value: "both" },
              ]}
              handleChange={handleChange}
              disabled={singleSelectDisabled}
            />
          </Grid>
          {photoType !== "both" &&
          <>
            <Grid item>
              <Typography variant="subtitle1" style={{marginTop: 10, marginLeft: 16}}>
                {photoType === "taken" ? "撮影数：" : "未撮影数："}
                {mapData.length > 0 && !pageTopLoader ? mapData.length : "--"}
              </Typography>
            </Grid>
            <Grid item style={{paddingTop: 18, marginLeft: 16}}>
              <Typography variant="caption">
                {photoType === "taken" ? "* %表示は撮影済み総数に占める割合です" : "* %表示は未撮影総数に占める割合です"}
              </Typography>
            </Grid>
          </>
          }
          {photoType === "both" &&
          <>
          <Grid item>
            <Typography variant="subtitle1" style={{marginTop: 10, marginLeft: 16}}>
              撮影数：
              {mapData.length > 0 && !pageTopLoader ? photoShootMapData?.taken.length : "--"}
            </Typography>
          </Grid>
          <Grid item>
           <Typography variant="subtitle1" style={{marginTop: 10, marginLeft: 16}}>
             未撮影数:
             {mapData.length > 0 && !pageTopLoader ? photoShootMapData?.untaken.length : "--"}
           </Typography>
          </Grid></>
          }
        </Grid>

        {mapData.length > 0 &&
          <PhotoShootMapHokuden
            records={mapData}
            type="photoshoot"
            width="100%"
            height="85vh"
            status={chartSize === undefined ? "taken" : chartSize.value}
            seasonId={
              selectedSeason.length > 0
                ? selectedSeason[0]["seasonId"]
                : false
            }
            photoShootMapData={photoShootMapData}
          />
        }
        {mapData.length == 0 &&
          <PhotoShootMapHokuden
            records={[]}
            type="photoshoot"
            width="100%"
            height="85vh"
            status="taken"
            seasonId={
              selectedSeason.length > 0
                ? selectedSeason[0]["seasonId"]
                : false
            }
            photoShootMapData={photoShootMapData}
          />
        }
      </C.ContentWrapper>
    </Fragment>
  );
};

PicTreeMapHokuden.propTypes = {
  classes: PropTypes.object,
};

const mapStateToProps = (state) => ({
  currentPage: state.page.currentPage,
  pageTopLoader: state.page.pageTopLoader,
  photoShootMapData: state.pictreeHokuden.photoShootMapData,
  dateRangePicTreeHokuden: state.page.dateRangePicTreeHokuden,
  selectedSeason: state.pictreeHokuden.selectedSeason,
});

const mapDispatchToProps = (dispatch) => ({
  setCurrentPage: (param) => dispatch(setCurrentPage(param)),
  getPhotoShootMapDataHokuden: (param) => dispatch(getPhotoShootMapDataHokuden(param)),
  setPictreeMapType: (param) => dispatch(setPictreeMapType(param)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(HomeStyles, { withTheme: true })(PicTreeMapHokuden));
